import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { GlobalVariables } from '../../../global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private url = GlobalVariables.appURL;

  constructor(private _httpClient: HttpClient) { }

  public list(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/list', data);
  }

  public listById(id: string, data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/list/' + id, data);
  }

  public detail(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'users/' + id);
  }

  public getLinks(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'users/links/' + id);
  }

  public upgrade(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/upgrade', data);
  }

  public active(id: any,isActive:Boolean): Observable<any> {
    return this._httpClient.patch(this.url + 'users/active/' + id,{isActive:isActive});
  }
  
  public business_user_approve(id: any): any {
    return this._httpClient.patch(this.url + 'businessuser/storesuser/' + id + '/accept', {});
  }
  
  public delete(id: any): Observable<any> {
    return this._httpClient.delete(this.url + 'users/' + id);
  }

  public create(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users', data);
  }

  public update(data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'users/' + data.id, data);
  }

  public expiry_update(data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'users/expdate/' + data.id, data);
  }

  public profile_update(id:any, data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'users/profile/' + id, data);
  }

  //   public profile_category(id:any, data: any): Observable<any> {
  //   return this._httpClient.patch(this.url + 'users/profile/' + id, data);
  // }
  
  public profile_change_password(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/profile-change-password/', data);
  }

  public sendnotification(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/notification', data);
  }

  public profile_photo(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/profile-photo', data);
  }

  public company_logo(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'organization/logo', data);
  }

  public company_brand_logo(id: string, data: any): Observable<any> {
    return this._httpClient.post(this.url + 'organization/logo/' + id, data);
  }

  public subscribe(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'organization/subscribe', data);
  }

  public media(id:any, data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'users/medialinks/' + id, data);
  }
  public media1(id:any,type:any, data: any): Observable<any> {
    const  dt= {mediaType:type,mediaValue:data}
    return this._httpClient.patch(this.url + 'users/medialinks/' + id, dt);
  }
   public media_delete(id:any, data: any , body: { mediaType: string; mediaValue: string }): Observable<any> {
    return this._httpClient.patch(this.url + 'users/medialinks/delete/' + id, data);
  }
   public cover_photo(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'organization/cover-photo', data);
  }

     public user_info(id:any): Observable<any> {
    return this._httpClient.get(this.url + 'business-users/'+ id  + '/name',  {});
  }

    public banner(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'banners', data);
  }

    public bannerUpdate(id:any, data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'banners/' + id, data);
  }

  public getBanners(): Observable<any> {
  return this._httpClient.get(this.url + 'banners');          
}

public getBannerID(id: any): Observable<any> {
  return this._httpClient.get(this.url + 'banners/' + id);   
}

  public usersActiveBanner(id:any, data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'users/banner-active/' + id, data);
  }

  public managementStats(): Observable<any> {
    return this._httpClient.post(this.url + 'users/management/stats', {});
  }

  public exportUsers(data: any): Observable<HttpResponse<Blob>> {
    return this._httpClient.post(this.url + 'users/management/export', data, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  public adminSetPassword(data: { userId: string; newPassword: string }): Observable<any> {
    return this._httpClient.post(this.url + 'users/admin-set-password', data);
  }

}

